var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarningOrange(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4823 10.3128C13.9073 11.0627 13.3738 12 12.5249 12H1.47492C0.624398 12 0.0933655 11.0612 0.517556 10.3128L6.04263 0.562149C6.46785 -0.188062 7.53289 -0.186703 7.95736 0.562149L13.4823 10.3128ZM6.99999 8.29688C6.41501 8.29688 5.94078 8.77957 5.94078 9.375C5.94078 9.97043 6.41501 10.4531 6.99999 10.4531C7.58498 10.4531 8.0592 9.97043 8.0592 9.375C8.0592 8.77957 7.58498 8.29688 6.99999 8.29688ZM5.99436 4.42158L6.16517 7.60908C6.17316 7.75823 6.29433 7.875 6.44107 7.875H7.55891C7.70566 7.875 7.82682 7.75823 7.83481 7.60908L8.00562 4.42158C8.01426 4.26047 7.88823 4.125 7.72972 4.125H6.27024C6.11173 4.125 5.98573 4.26047 5.99436 4.42158Z",
    fill: "#C43232"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningOrange);
export default __webpack_public_path__ + "static/media/warning-orange.1c399e53.svg";
export { ForwardRef as ReactComponent };